import script from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=b98e8066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b98e8066"]])

export default __exports__